export enum TransactionFilter {
    'transactionYears' = 'transactionYears',
    'transactionTypes' = 'transactionTypes',
    'contracts' = 'contracts',
    'usageYears' = 'usageYears',
    'usageTypes' = 'usageTypes',
    'userName' = 'userName'
};

export interface TransactionFilters {
    [TransactionFilter.transactionYears]: Array<string|number>;
    [TransactionFilter.transactionTypes]: Array<string|number>;
    [TransactionFilter.contracts]: Array<string|number>;
    [TransactionFilter.usageYears]: Array<string|number>;
    [TransactionFilter.usageTypes]: Array<string|number>;
    [TransactionFilter.userName]: Array<string|number>;
};

export enum UsageFilter {
    'contracts' = 'contracts',
    'usageYears' = 'usageYears',
    'usageTypes' = 'usageTypes'
}

export interface UsageTransactionFilters {
    [UsageFilter.contracts]: string[];
    [UsageFilter.usageYears]: number[];
    [UsageFilter.usageTypes]: string[];
};

export interface BaseTransaction {
    id: number;
    date: string;
    type: string;
    amount: number;
    description: string;
};

export interface TransactionsByUsage {
    contractId: string;
    usageType: string;
    usageYear: number;
    startDate: string;
    endDate: string;
    allocated: number;
    remaining: number;
    transactions: BaseTransaction[];
};

export interface TransactionExtended extends BaseTransaction {
    contractId: string;
    usageType: string;
    usageYear: number;
};
